<template>
  <div class="pa-4 d-flex flex-column ga-4">
    <v-alert
      type="info"
      variant="tonal"
      density="comfortable">
      Paste any Dropbox share link. CanvasPro will normalize it for direct
      download and upload the file into your current asset context.
    </v-alert>

    <v-text-field
      v-model="dropboxUrl"
      label="Dropbox Share Link"
      placeholder="https://www.dropbox.com/s/abc123/MyVideo.mp4?dl=0"
      prepend-inner-icon="mdi-link-variant"
      density="comfortable"
      clearable />

    <v-text-field
      :model-value="assetName"
      label="Asset Name"
      placeholder="Auto-detected from link"
      prepend-inner-icon="mdi-format-title"
      density="comfortable"
      clearable
      @update:modelValue="onNameInput" />

    <v-select
      v-model="conflictStrategy"
      :items="conflictOptions"
      label="If an asset with this name exists"
      item-title="title"
      item-value="value"
      density="comfortable"
      hide-details="auto" />

    <v-alert
      v-if="groupHint"
      type="warning"
      variant="tonal"
      density="comfortable"
      class="ma-0">
      {{ groupHint }}
    </v-alert>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { state } from '../../../stores/deluge.js';

const emit = defineEmits(['update:data']);

const dropboxUrl = ref('');
const assetName = ref('');
const conflictStrategy = ref('rename');
const nameTouched = ref(false);

const conflictOptions = [
  { title: 'Rename automatically if needed', value: 'rename' },
  { title: 'Upgrade existing asset', value: 'upgrade' },
  { title: 'Cancel the import', value: null },
];

function emitData() {
  emit('update:data', {
    url: dropboxUrl.value.trim(),
    name: assetName.value.trim(),
    conflict: conflictStrategy.value,
  });
}

watch(
  () => [dropboxUrl.value, assetName.value, conflictStrategy.value],
  emitData,
  { immediate: true }
);

watch(
  () => dropboxUrl.value,
  (value) => {
    if (nameTouched.value && assetName.value) {
      return;
    }
    const derived = deriveNameFromUrl(value);
    if (derived) {
      assetName.value = derived;
    }
  }
);

function deriveNameFromUrl(url) {
  try {
    const parsed = new URL(url);
    const segments = parsed.pathname.split('/').filter(Boolean);
    return decodeURIComponent(segments.pop() || '');
  } catch (e) {
    return '';
  }
}

function onNameInput(value) {
  assetName.value = value || '';
  nameTouched.value = !!value;
  emitData();
}

const groupHint = computed(() => {
  if (!state.current_asset_group) {
    return '';
  }
  return 'Uploads will be assigned to the asset group you are currently browsing.';
});
</script>
